import Cookies from 'js-cookie';

import { cookieKeyLink, cookieKeyErrmessage, cookieKeyNotion, cookieKeyAgencyIds } from './const';

// link
const setCookieLink = (data) => {
    Cookies.set(cookieKeyLink, JSON.stringify(data), { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const getCookieLink = () => {
    return Cookies.get(cookieKeyLink, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const removeCookieLink = () => {
    Cookies.remove(cookieKeyLink, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const getCookieAgencyIds = () => {
    return Cookies.get(cookieKeyAgencyIds, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB })
};

const setCookieAgencyIds = (data) => {
    Cookies.set(cookieKeyAgencyIds, JSON.stringify(data), { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB })
}

// message
const setCookieMessage = (data) => {
    Cookies.set(cookieKeyErrmessage, JSON.stringify(data), { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const getCookieMessage = () => {
    return Cookies.get(cookieKeyErrmessage, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const removeCookieMessage = () => {
    Cookies.remove(cookieKeyErrmessage, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

// thông báo hết hạn
const setCookieNotion = (data) => {
    Cookies.set(cookieKeyNotion, JSON.stringify(data), { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const getCookieNotion = () => {
    return Cookies.get(cookieKeyNotion, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

const removeCookieNotion = () => {
    Cookies.remove(cookieKeyNotion, { path: '/', domain: process.env.REACT_APP_DOMAIN_WEB });
};

export {
    setCookieLink,
    getCookieLink,
    removeCookieLink,
    setCookieMessage,
    getCookieMessage,
    removeCookieMessage,
    setCookieNotion,
    getCookieNotion,
    removeCookieNotion,
    getCookieAgencyIds,
    setCookieAgencyIds
};
